import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'roles',
    collectionActionName: 'OFFICE_ROLES',
    itemActionName: 'OFFICE_ROLE',
});
